import React from 'react';
import ArrowButtonHorz from './ArrowButton';
import ArrowButtonVert from './ArrowButtonVert';
import DialButton from './DialButton';
import NumericButtonsGroup from './NumericButtonsGroup';

const ArrowButtonGroup = (props) => {
    const { radio } = props;

    return (
        <div className="col-6 box_clavier_radio">
            <div className="row">
                <div className="col-4 mt-5">
                    <DialButton color={'rouge'} radio={radio} />
                    <div className="btn_tel_menu">
                        <div className="btn_top">
                            <ArrowButtonVert direction={'haut'} radio={radio} />
                        </div>
                        <div className="btn_middle">
                            <ArrowButtonHorz direction={'gauche'} radio={radio} />
                            <ArrowButtonHorz direction={'droite'} radio={radio} />
                        </div>
                        <div className="btn_bottom">
                            <ArrowButtonVert direction={'bas'} radio={radio} />
                        </div>
                    </div>
                    <DialButton color={'vert'} radio={radio} />
                </div>
                <NumericButtonsGroup radio={radio} />
            </div>
        </div>
    );
};

export default ArrowButtonGroup;
